/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

/**
 * Service for handling Ably authentication and token management
 */

export const requestAblyToken = async () => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.ABLY.REQUEST_TOKEN}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
